import { Component, Element, Listen, Prop, State,Watch,h } from "@stencil/core";
import '../../../stories/Components/ContactInfo/ContactInfo';
import '../../../stories/Components/ContactInfo/ProfileInfo';
import ChatSDK from 'test-iso-chat-sdk';
import { showToast } from "../../../stories/Components/Toaster/toast-helper";
import { groupMembersStore } from "../../../store/group-members";
import { conversationStore } from "../../../store/conversation";
import { makeAdmin, removeAdmin } from '../../../api/membership-control';
import '../../../stories/Components/MessageSearch/MessageSearch';
import{ drawerDialogService } from '../../../stories/Components/Dialog-Drawer/dialog-drawer.js';
@Component({
  tag: 'web-chat-right-sidebar',
  shadow: true,
  styles: ``
})
export class WebChatRightSide {

@Prop()  conversationMetaData: any = {};
@Prop()  selectedConversationId: string | null = null;
@Prop()  conversationIdFromContactinfo: string | null = null;
@Prop()  hasMoreEligibleMembers: boolean = true;
@Prop() isContactInfoOpen:boolean =false;
@Prop() isProfileInfoOpen:boolean =false;
@Prop() eligibleMembers: any[] = [];
@Prop() allAttachments:[]
@Prop()  userMetaData: any = null;
@Prop() messageAction: { action: string; initiator: boolean } = { action: "", initiator: false };
@State() groupMembers: any[] = [];
@State() isLoading: boolean = false;
@Prop() searchedMessageDetails:any[] = [];
@Prop() onSearchHandler: (text: string) => void;
@Prop() onSearchResultClick: (messageId: string) => Promise<void>;
@Prop() handleChatSelect: (conversationId: string) => void;
@Prop() openOwnProfile: () => void;
@Prop() isOpenSearchBar: boolean = false;
@Prop() isLoadingMessage: boolean = false;
@Element() el: HTMLElement;
@Prop() chatBodyRef: HTMLWebChatBodyElement;
@Prop() allLinks: any;
@Prop() allLinksCount: number;
@Prop() isBlocked: boolean | string = null;
@Prop() groupcastMembers: any = [];

@Listen('remove-admin-clicked')
async handleRemoveAdmin(event: CustomEvent) {
  const { userId, username } = event.detail;
  try {
    this.isLoading = true;
    await removeAdmin(this.selectedConversationId, userId);
     groupMembersStore.updateAdminStatus(userId, false);
  this.groupMembers = this.groupMembers.map(member => 
    member.userId === userId ? { ...member, isAdmin: false } : member
  );
  this.el.dispatchEvent(new CustomEvent('admin-status-changed', {
    detail: {
      userId,
      isAdmin: false
    },
    bubbles: true,
    composed: true
  }));
    showToast({
      message: `${username} is no longer an admin`,
      type: 'success',
      duration: 4000,
      position: 'bottom-left'
    });
  } catch (error) {
    groupMembersStore.updateAdminStatus(userId, true);
    this.groupMembers = this.groupMembers.map(member => 
      member.userId === userId ? { ...member, isAdmin: true } : member
    );

    showToast({
      message: 'Failed to remove admin',
      type: 'error',
      duration: 4000,
      position: 'bottom-left'
    });
  } finally {
    this.isLoading = false;
    drawerDialogService.closeDialog('confirm-dialog');
  }
}

@Listen('make-admin-clicked')
  async handleMakeAdmin(event: CustomEvent) {
    const { userId, username } = event.detail;

    try {
      this.isLoading = true;
      await makeAdmin(this.selectedConversationId, userId);
        groupMembersStore.updateAdminStatus(userId, true);

    this.groupMembers = this.groupMembers.map(member => 
      member.userId === userId ? { ...member, isAdmin: true } : member
    );

    this.el.dispatchEvent(new CustomEvent('admin-status-changed', {
      detail: {
        userId,
        isAdmin: true
      },
      bubbles: true,
      composed: true
    }));
      showToast({
        message: `${username} is now an admin`,
        type: 'success',
        duration: 4000,
        position: 'bottom-left'
      });
    } catch (error) {
      groupMembersStore.updateAdminStatus(userId, false);
      this.groupMembers = this.groupMembers.map(member => 
        member.userId === userId ? { ...member, isAdmin: false } : member
      );
      showToast({
        message: 'Failed to make user admin',
        type: 'error',
        duration: 4000,
        position: 'bottom-left'
      });
    } finally {
      this.isLoading = false;
      drawerDialogService.closeDialog('confirm-dialog');
    }
  }
  

   handleEditGroupTitle = async (conversationTitle: string, conversationId: string) => {
    try {
      await ChatSDK.getInstance().Conversation.patchTitle({conversationId: conversationId, conversationTitle: conversationTitle});
      showToast({
        message: 'Group title updated successfully',
        type: 'success',
        duration: 4000,
        position: 'bottom-left'
      });
    } catch (error) {
      console.error(error, 'error');
      showToast({
        message: 'Failed to update group title',
        type: 'error',
        duration: 4000,
        position: 'bottom-left'
      });
    }
   } 

   handleEditGroupImage = async (conversationImageUrl: string, conversationId: string) => {
    try {
       await ChatSDK.getInstance().Conversation.patchImage({conversationId: conversationId, conversationImageUrl: conversationImageUrl});
       showToast({
         message: 'Group image updated successfully',
         type: 'success',
         duration: 4000,
         position: 'bottom-left'
       });
    } catch (error) {
      console.error(error, 'error');
      showToast({
        message: 'Failed to update group image',
        type: 'error',
        duration: 4000,
        position: 'bottom-left'
      });
    }
   }

   @Listen('edit-title')
   async handleEditTitle (event: CustomEvent) {
    const { currentTitle, newTitle, conversationId, onError } = event.detail;
    
    if (newTitle && newTitle !== currentTitle) {
      try {
        // Update conversation details optimistically
        this.conversationMetaData.conversationTitle = newTitle;
        this.conversationMetaData = {
          ...this.conversationMetaData,
          conversationTitle: newTitle
        };

        conversationStore.updateTitle(newTitle);

        await this.handleEditGroupTitle(newTitle, conversationId);

        // Emit event to notify parent that conversation details need to be refreshed
        this.el.dispatchEvent(new CustomEvent('conversation-updated', {
          detail: {
            conversationId,
            type: 'title',
            value: newTitle
          },
          bubbles: true,
          composed: true
        }));

      } catch (error) {
        console.error('Failed to update title:', error);
        if (onError) onError();
        this.conversationMetaData = {
          ...this.conversationMetaData,
          conversationTitle: currentTitle
        };
        conversationStore.updateTitle(currentTitle);
      }
    }
  }

  @Listen('edit-image')
  async handleEditImage (event: CustomEvent) {
    const { currentImage, conversationId, file, onError, onSuccess } = event.detail;
    
    if (file) {
      try {
        // Get presigned URL
        const response = await ChatSDK.getInstance().message.postMessagesPresignedurls({
          conversationId,
          attachments: [{
            nameWithExtension: file.name,
            mediaType: 0, // for image
            mediaId: Date.now().toString(),
          }]
        });

        if (response?.presignedUrls?.[0]) {
          const { mediaPresignedUrl, mediaUrl } = response.presignedUrls[0];
          
          // Upload to presigned URL
          await fetch(mediaPresignedUrl, {
            method: 'PUT',
            body: file,
            headers: {
              'Content-Type': file.type,
            },
          });

      await this.handleEditGroupImage(mediaUrl, conversationId)
          
          // Update conversation details with the new image URL
          this.conversationMetaData = {
            ...this.conversationMetaData,
            conversationImageUrl: mediaUrl
          };

          if (onSuccess) onSuccess();
        }
      } catch (error) {
        console.error('Failed to update image:', error);
        if (onError) onError();
        
        // Revert optimistic update in conversation details
        this.conversationMetaData = {
          ...this.conversationMetaData,
          conversationImageUrl: currentImage
        };
      }
    }
  }
  handleSearchInput = (searchText: string) => {
    this.onSearchHandler(searchText)
  }
  @Watch('selectedConversationId')
  async updateConversation(){
    this.el.dispatchEvent(new CustomEvent('close-right-Sidebar', {
      detail: {
        type: 'close-right-Sidebar',
      },
      bubbles: true,
      composed: true
    })); 
  }
  render() {
    // Return the right sidebar content or null if nothing should be displayed
    if (this.isContactInfoOpen) {
      return (
        <contact-info
          height="100dvh"
          width="100%"
          boxShadow="-3px 0px 7px var(--bg-grey-color)"
          backgroundColor="var(--bg-secondary-color)"
          textColor='var(--text-primary-color)'
          contactName={this.conversationMetaData?.groupcastId ? this.conversationMetaData?.groupcastTitle : this.conversationMetaData?.conversationTitle || this.conversationMetaData?.opponentDetails?.userName}
          contactEmail={this.conversationMetaData?.opponentDetails?.userIdentifier}
          oppenentId={this.conversationMetaData?.opponentDetails?.userId}
          messageAction={this.messageAction}
          isGroup={this.conversationMetaData?.isGroup}
          contactImage={this.conversationMetaData?.groupcastId ? this.conversationMetaData?.groupcastImageUrl : this.conversationMetaData?.isGroup ? this.conversationMetaData.conversationImageUrl : this.conversationMetaData?.opponentDetails?.userProfileImageUrl}
          groupMembers={this.conversationMetaData?.members || this.conversationMetaData?.metaData?.members}
          allAttachments={this.allAttachments}
          close-contact-info={() => (this.isContactInfoOpen = false)}
          conversationId={this.selectedConversationId}
          userMetaData={this.userMetaData}
          eligibleMembers={this.eligibleMembers}
          hasMoreEligibleMembers={this.hasMoreEligibleMembers}
          openOwnProfile={this.openOwnProfile}
          allLinks={this.allLinks}
          allLinksCount={this.allLinksCount}
          isBlocked={this.isBlocked}
          conversationMetaData={this.conversationMetaData}
          groupcastMembers={this.groupcastMembers}
        ></contact-info>
      );
    }
    if (this.isProfileInfoOpen) {
      return (
        <profile-info
          height="100dvh"
          width="100%"
          boxShadow="-3px 0px 7px var(--bg-grey-color)"
          backgroundColor="var(--bg-secondary-color)"
          textColor='var(--text-primary-color)'
          contactName={this.conversationMetaData?.conversationTitle || this.conversationMetaData?.opponentDetails?.userName}
          contactEmail={this.conversationMetaData?.opponentDetails?.userIdentifier}
          oppenentId={this.conversationMetaData?.opponentDetails?.userId}
          messageAction={this.messageAction}
          isGroup={false}
          contactImage={this.conversationMetaData?.isGroup ? this.conversationMetaData.conversationImageUrl : this.conversationMetaData?.opponentDetails?.userProfileImageUrl}
          groupMembers={this.conversationMetaData?.members}
          allAttachments={this.allAttachments}
          close-contact-info={() => (this.isProfileInfoOpen = false)}
          conversationId={this.conversationIdFromContactinfo}
          userMetaData={this.userMetaData}
          eligibleMembers={this.eligibleMembers}
          hasMoreEligibleMembers={this.hasMoreEligibleMembers}
          handleChatSelect={this.handleChatSelect}
          isBlocked={this.isBlocked}
          conversationMetaData={this.conversationMetaData}
        ></profile-info>
      );
    }
    
    if (this.isOpenSearchBar) {
      return (
        <message-search
          onSearchResultClick={this.onSearchResultClick}
          onSearchHandler={this.onSearchHandler}
          searchedMessageDetails={this.searchedMessageDetails}
          onSearchInput={this.handleSearchInput}
          chatBodyRef={this.chatBodyRef}
          isLoadingMessage={this.isLoadingMessage}
        ></message-search>
      );
    }
    
    // Return null or an empty container when nothing should be displayed
    return null;
  }
}